import axios from 'axios';

import { API_BASE_URL } from './apiBase';
import { attendeeErrorMessage } from './attendeeErrors';
import {
  ATTENDEE_SESSION_ENDED,
  clearAttendeeSession,
  readAttendeeSession,
  shouldEndAttendeeSession,
} from '../utils/attendeeSession';
import { bearerFromHeaders } from '../utils/sessionGuard';

export { attendeeErrorMessage };

const hackathonApi = axios.create({
  baseURL: `${API_BASE_URL}/hackathon`,
  headers: { 'Content-Type': 'application/json' },
});

hackathonApi.interceptors.request.use((config) => {
  const token = readAttendeeSession()?.token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Só encerra a sessão quando o 401 veio do token atual: uma resposta atrasada de um
// token antigo não derruba o login feito depois.
hackathonApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldEndAttendeeSession({
      status: error?.response?.status,
      code: error?.response?.data?.code,
      requestToken: bearerFromHeaders(error?.config?.headers),
      currentToken: readAttendeeSession()?.token,
    })) {
      clearAttendeeSession();
      window.dispatchEvent(new Event(ATTENDEE_SESSION_ENDED));
    }
    return Promise.reject(error);
  }
);

export default hackathonApi;
